((Utilities, ModelsRestProvider, CassiopeaTypesEnum, EditorElementDataManager, ReportsRestProvider) => {
	'use strict';
	const HIDDEN_CARDS	= 20;
	const CATALOGUE_USERS	= 11111;
	const GRID_VIEW = 'grid';
	
	let descriptionLabel 	= Utilities.getTranslation('Description');
	let nameLabel 			= Utilities.getTranslation('Name');
	
	class LandingPageController {

		constructor($scope, dcyHTTPRequestService, dcyDialogFactory, $timeout, dcyLandingPageFactory, dcyNavigationManagerUtilsFactory) {
			this.$scope 				= $scope;
			this.dcyHTTPRequestService 	= dcyHTTPRequestService;
			this.dcyDialogFactory 		= dcyDialogFactory;
			this.dcyLandingPageFactory	= dcyLandingPageFactory;
			this.$timeout 				= $timeout;
			this.templateMangerInstance	= this.$scope.template;
			this.modelsRestProvider		= new ModelsRestProvider();
			this.applications   		= this.$scope.DECISYON.target.content.data.models.list.slice();
			this.currentUserId			= ENV_VARS.getCurrentUserInfo().id;
			this.dcyNavigationManagerUtilsFactory				= dcyNavigationManagerUtilsFactory;
			this.fadeIn 				= false;
			this.moreAppsViewable		= true;
			this.showTimeout			= null;
			this.delayTooltip 			= 1000;	
			this.lastEventTriggered 	= 0;
			this.resourcePath 			= this.$scope.DECISYON.template.resourcePath;			
			this.viewMode 				= GRID_VIEW;
			this.tabs = new Map();
			this.tabs.set('myReportsList', this.resourcePath + '/views/myReportsList/myReportsList.template.html');
			this.tabs.set('publishedContents', this.resourcePath + '/views/publishedContents/publishedContents.template.html');
			this.gridCardsView 			= this.resourcePath + '/views/grid_cards/grid_cards.template.html'
			this.editorElementDataManager = new EditorElementDataManager(CassiopeaTypesEnum.REPORT);
			this.reportsRestProvider = this.editorElementDataManager.provider;
			this.defaultMyReportsFilter = 'root.nodes.'+this.currentUserId;
			this.defaultContentsFilter = 'root';
			this._initializeVM();
			this._watchListener();
		}
		
		goToContentOrganizerSection(application, event){
			let selectedModelOwnerParam =  '&dcyContentOrganizer_selectedModelOwner='+application.owner;
			let url = '../dsh/dshPage.jsp.cas?revent=LW_DSH_LINK&dshID=191534859180199&csMLO=MASTERM'+selectedModelOwnerParam;
			rootPage.startLoadingPage(1);
			RouterAsyncBridge.getBridge().then((bridge) => {
				bridge.ROUTING_MANAGER.navigateToRoute(bridge.EROUTES.ORGANIZER_EDIT, url);
			});
		}
		
		updateDataByComponentType(type){
			let _self = this;
			switch (type) {
				case 'MODEL_IMAGE':
					_self.templateMangerInstance.update();
					break;
				case 'MSHPAGE_PREVIEW':
				case 'PLN_PROCESS_PREVIEW':
					_self._updateMashboardsByIndex(_self.selectedApplicationIndex);
					break;
				default:
					break;
			}
		}

		_watchListener(){
			let _self = this;
			let unbindWatches = [];

			unbindWatches.push(_self.$scope.$watch('DECISYON.target.content.data.models.list', function(newApplications, oldApplications){
				if(newApplications !== oldApplications){
					_self.applications = _.values(_.merge({}, _self.applications, newApplications));	
				}
			}, true));

			unbindWatches.push(_self.$scope.$watchCollection('[ctrl.selectedApplicationIndex, ctrl.selectedIndexTab, ctrl.contentNavigationFilter, ctrl.myReportNavigationFilter]', function(newValues, oldValues){
				if(Utilities.isValidArray(oldValues) &&  newValues !== oldValues && !_.filter(newValues, (o) => { return o == undefined ;}).length){
					RouterAsyncBridge.getBridge().then((bridge) => {
						var oldApplicationIndexSelected = oldValues[0];
						var newApplicationIndexSelected = newValues[0];
						var selectedIndexTab = newValues[1];
						var contentNavigationFilter = newValues[2];
						var myReportNavigationFilter = newValues[3];
						//Manage navigation on my report tab selection
						if(selectedIndexTab == 1 && oldApplicationIndexSelected != newApplicationIndexSelected){
							if(!Utilities.isUndefinedOrNull(myReportNavigationFilter)){
								let isReportFilterValid = !Utilities.isUndefinedOrNull(_.get(_self.myReportList, myReportNavigationFilter));
								if(!isReportFilterValid){
									myReportNavigationFilter = _self.defaultMyReportsFilter;
								}
							}
						}
						var ctx = JSON.stringify({ 'selectedApplicationIndex' :  newApplicationIndexSelected, 'selectedIndexTab' :  selectedIndexTab, 'contentNavigationFilter' : contentNavigationFilter, 'myReportNavigationFilter' : myReportNavigationFilter  });
						bridge.ROUTING_MANAGER.navigateToRoute(bridge.EROUTES.HOME, ctx, false);
					});	
				}
			}, true));

			_self.$scope.$on('dcy.imageUploadForm.complete', function($event, newData, component){
				_self.updateDataByComponentType(component.definerOptions.imgType);
			});

			rootPage.addEventListener('dcy.updateHomeStateNavigation', (e) => {
				let _self = this;
				Utilities.stopPropagation(e);
				var detail = e.detail;
				if(Utilities.isUndefinedOrNull(detail.selectedApplicationIndex)){
					return history.go(-1);
				}
				if(detail.selectedIndexTab != _self.selectedIndexTab || 
					detail.selectedApplicationIndex != _self.selectedApplicationIndex ||
						detail.contentNavigationFilter != _self.contentNavigationFilter ||
							detail.myReportNavigationFilter != _self.myReportNavigationFilter){
					
					let appIndexToSelect 	= detail.selectedApplicationIndex;
					if(_self.applications && _self.applications.length === 1){
						_self.moreAppsViewable = false;
					}else if(Utilities.isUndefinedOrNull(appIndexToSelect)){
						let selectedModel = window.csMLO;
						if (!_.isEmpty(_self.$scope.DECISYON.target.content.ctx)) {
							let model = _self.$scope.DECISYON.target.content.ctx.selectedModel.value;
							selectedModel = model == 'NA' ? selectedModel : model;
						} 
						appIndexToSelect = _.findIndex(_self.applications, ['owner', selectedModel]);
					}		
					
					_self.saveStateNavigation(detail.selectedIndexTab, appIndexToSelect, detail.contentNavigationFilter || _self.defaultContentsFilter, detail.myReportNavigationFilter);
					_self.$scope.$applyAsync();
				}
			});
			
			_self.$scope.$on('$destroy', function () {
				for(var i = 0; i < unbindWatches.length; i++){
					unbindWatches[i]();
				}
			});		
		}

		_updateMashboardsByIndex(index){
			let _self = this;
			_self._getMashboardsByAppIndex(index).then(response => {
				_self.mashboards = { root : response.root };
				_self.$scope.$applyAsync();
			});
		}

		_getHiddenCards() {
			return new Array(HIDDEN_CARDS);
		}

		_getMenuComponent(id, owner, imgType, fuCtxType, srcImage){
			let _self = this;
			return _self.dcyLandingPageFactory.getMenuComponent(id, owner, imgType, fuCtxType, srcImage);
		}

		_manageApplication(index){
			let _self = this;
			let application = this.applications[index];
			_self.selectedApplicationIndex = index;

			if(!application.menuComponent){
				application.menuComponent = _self._getMenuComponent(application.id, application.owner, 'MODEL_IMAGE', 'IMAGE_PROFILER', application.srcImage);
			}

			if (_self.showTimeout) {
				_self.$timeout.cancel(_self.showTimeout);
				_self.showTimeout = null;
			}

			_self.showTimeout = _self.$timeout(function() {
				_self.fadeIn = true;
			},100);		 
		}

		_getUploadType(casType){
			let _self = this;
			return _self.dcyLandingPageFactory.getUploadType(casType);
		}

		_getMashboardsByAppIndex(index) {
			let _self = this;
			let promise = new Promise(function(resolve, reject) {
				let filters = {};
				filters.onlyPublished   = true;
				filters.hideEmptyFolder	= true;
				_self.modelsRestProvider.getOrganizer(_self.applications[index].owner, filters).$promise.then(response => {
					resolve(response);
				}, err => {
					reject(err);
				});
			});
			return promise;
		}
		
		_setPublishedContentsSection(index){
			let _self = this;
			_self.fadeIn = false;
			_self.$scope.$applyAsync();
			_self._getMashboardsByAppIndex(index).then((response) => {
				var params = {
						httpRequestType: 'POST',
						subPath: '/cassiopeaWeb/report/empty.jsp.cas',
						params: {
							csMLO        : _self.applications[index].owner,
							setMainModel : 1,
							pageUIDIdentifier: (typeof rootPage.pageUIDIdentifier != 'undefined') ? rootPage.pageUIDIdentifier : '',
									revent: 'LW_EVENT'
						}
				};
				_self.dcyHTTPRequestService(params).then((response) => {}, (reason) => {});
				_self._manageApplication(index);
				_self.mashboards = { root : response.root };
				_self.listFilter = _self.defaultContentsFilter;
			}).catch( err => {
				_self.mashboards = null;
				console.error(err);
			});
		}
		
		_getMyReportsList(index){
			let _self = this;
			let promise = new Promise(function(resolve, reject) {
				_self.reportsRestProvider.getMyReportListByOwner(_self.applications[index].owner, true).$promise.then(response => {
					resolve(response);
				}, err => {
					reject(err);
				});
			});
			return promise;
		}
		
		_setMyReportsSection(index){
			let _self = this;
			_self._getMyReportsList(index).then((response) => {
				if (response.root && response.root.nodes && response.root.nodes[CATALOGUE_USERS]){
					_self.myReportList = { root : response.root.nodes[CATALOGUE_USERS]};
					_self.myReportsFilter = _self.defaultMyReportsFilter;
				}else{
					_self.myReportList = null;
					_self.myReportsFilter = _self.defaultMyReportsFilter;
				}
				
			}).catch( err => {
				_self.myReportList = null;
				_self.myReportsFilter = _self.defaultMyReportsFilter;
				console.error(err);
			});
		}
		
		_selectApplication(index, contentNavigationFilter, myReportNavigationFilter) {
			let _self = this;
			if (_self.selectedApplicationIndex === undefined){
				_self.contentNavigationFilter = contentNavigationFilter;
				_self.myReportNavigationFilter = myReportNavigationFilter;
				_self._setPublishedContentsSection(index);
				_self._setMyReportsSection(index);
			}else{
				if (_self.selectedApplicationIndex !== index) {
					_self.contentNavigationFilter = _self.defaultContentsFilter;
					_self.myReportNavigationFilter = _self.defaultMyReportsFilter;
					_self._setPublishedContentsSection(index);
					_self._setMyReportsSection(index);
				}
				else{
					_self.listFilter = _self.defaultContentsFilter;
				}
			}			
		}

		getTemplateById(id) {
			return this.tabs.get(id);
		}
			
		_openPageMenu($mdMenu, $event, page) {
			$event.stopPropagation();
			$mdMenu.open($event);
		}

		_isModelEditable(){
			let _self = this;
			let selectedApp = _self.applications[_self.selectedApplicationIndex];
			return selectedApp && selectedApp.isModelEditable;
		}

		_hasPagesAvailable(){
			let _self = this;
			return (_self.mashboards &&  _self.mashboards.root && _self.mashboards.root.nodes && Object.keys(_self.mashboards.root.nodes).length > 0);
		}
		
		_hasMyReportsAvailable(){
			let _self = this;
			let hasMyReports = (_self.myReportList && _self.myReportList.root.nodes && _self.myReportList.root.nodes[_self.currentUserId] && _self.myReportList.root.nodes[_self.currentUserId].nodes && Object.keys(_self.myReportList.root.nodes[_self.currentUserId].nodes).length > 0);
			return (hasMyReports!=undefined ? true : false);
		}
		
		_hasMorePagesAvailable(){
			let _self = this;
			return (_self.mashboards && _self.mashboards.root.nodes && Object.keys(_self.mashboards.root.nodes).length > 1);
		}

		_hasApplicationAvailable(){
			let _self = this;
			return (_self.applications && _self.applications.length > 0);
		}
		
		openItem(section, node, listNavCtrl, $event){
			let _self = this;
			var lastEventTriggered = 0;
			Utilities.preventMoreEventTriggered($event, _self.lastEventTriggered, 500, (actualDateTriggered) => {
				_self.lastEventTriggered = actualDateTriggered;
				switch (node.type) {
					case '1':
						listNavCtrl.onDblClick($event, node);
						if(_self.selectedIndexTab == 1){
							_self.myReportNavigationFilter = node.nodeInfo.filter;
						}
						else{
							_self.contentNavigationFilter = node.nodeInfo.filter;
						}
						break;
					case '2':
						if (section === 'MYREPORTS'){
							_self.openMyReport(node);
						}
						else{
							_self.openPublishedContent(node);
						}
						break;
					default:
						break;
				}
			});			
		}
		
		openPublishedContent(node){
			let _self = this;
			openMashboardFromWelcome(_self.applications[_self.selectedApplicationIndex].owner, node.nodeInfo.id, node.parentId, node.nodeInfo.casType);
		}
		
		openMyReport(node){
			manageContentForwardReport(node.nodeInfo.owner || node.nodeInfo.modelOwner, node.nodeInfo.id);
		}
		
		getItemPreviewImage(item){
			let _self = this;
			if (item.nodeInfo && item.nodeInfo.previewImage){
				return item.nodeInfo.previewImage;
			}
			return _self.$scope.DECISYON.template.resourcePath + '/img/report.png';
		}
		
		getTitleByType(page){
			let _self = this;
			return _self.dcyLandingPageFactory.getTitleByContent(page);
		}

		_isSelected(index) {
			return index === this.selectedApplicationIndex;
		}

		_goToMashboardSection(application, event){
			changeModelDashboardSection(application.owner, application.desc, event);			
		}
			
		isInGridView(){
			let _self = this;
			return _self.viewMode == GRID_VIEW;
		}
		
		onChangeViewMode(newViewMode){
			let _self = this;
			_self.viewMode = newViewMode;
		}
		
		changeViewMode($event, viewMode){
			if($event){
				$event.stopPropagation();
			}
			let _self = this;
			if (_self._hasPagesAvailable()){
				_self.fadeIn = true;
				_self.viewMode = '';
				_self.$timeout(function(){
					_self.viewMode = viewMode;	
					_self.$scope.$applyAsync(() => {
						_self.onChangeViewMode(viewMode);
					 });
				}, 0, false);
			}
		}
		
		saveStateNavigation(selectedIndexTab, selectedApplicationIndex, contentNavigationFilter, myReportNavigationFilter) {
			let _self = this;
			_self.selectedIndexTab 			= selectedIndexTab;
			_self.contentNavigationFilter 	= contentNavigationFilter;
			_self.myReportNavigationFilter 	= myReportNavigationFilter;
			_self._selectApplication(selectedApplicationIndex, contentNavigationFilter, myReportNavigationFilter);
		}

		hasSelectedAppDescription(){
			let _self = this;
			let selectedApp = _self.applications[_self.selectedApplicationIndex];
			return selectedApp && selectedApp.desc && selectedApp.desc != '';
		}
		
		_initializeVM() {
			let _self = this;
			
			let getIconByElement = (element) => {
				let _self = this;
				return _self.dcyNavigationManagerUtilsFactory.getIconByElement(element);
			};
			
			let openPublishedContent  = ($event, target) =>{
				let _self = this;
				$event.preventDefault();
				$event.stopPropagation();
				var nodeInfo = target.nodeInfo;
				if (target.type === '2'){
					_self.openPublishedContent(target);
				}
			};
				
			let openMyReport  = ($event, target) =>{
				let _self = this;
				$event.preventDefault();
				$event.stopPropagation();
				var nodeInfo = target.nodeInfo;
				if (target.type === '2'){
					_self.openMyReport(target);
				}
				
			};
			
			if (!_.isEmpty(_self.applications)){
				let appIndexToSelect 	= 0;
				if(_self.applications.length === 1){
					_self.moreAppsViewable = false;
				}else {
					if (!_.isEmpty(this.$scope.DECISYON.target.content.ctx)) {
						let selectedModel = _self.$scope.DECISYON.target.content.ctx.selectedModel.value;
						if (selectedModel !== 'NA') {
							appIndexToSelect = _.findIndex(_self.applications, ['owner', selectedModel]);
						}
					} 
				}				

				RouterAsyncBridge.getBridge().then((bridge) => {
					var fragment = bridge.ROUTING_MANAGER.getCurrentRouteFragment();
					var splittedFragment = fragment.match(bridge.EROUTES.HOME + '(.*)');
					var ctx ;
					if(splittedFragment && splittedFragment.length){
						var param = splittedFragment[1];
						if(param){
							var decodedParam = Utilities.isBase64String(param) ? Utilities.b64DecodeUnicode(param) : param;
							ctx = decodedParam ? JSON.parse(decodedParam) : ctx;
						}
					}
					var selectedIndexTab = 0;
					var selectedApplicationIndex = appIndexToSelect;
					var contentNavigationFilter = _self.defaultContentsFilter;
					var myReportNavigationFilter = _self.defaultMyReportsFilter;

					if(ctx){
						selectedIndexTab 			= ctx.selectedIndexTab ? ctx.selectedIndexTab : selectedIndexTab;
						selectedApplicationIndex 	= ctx.selectedApplicationIndex ? ctx.selectedApplicationIndex : selectedApplicationIndex;
						contentNavigationFilter 	= ctx.contentNavigationFilter ? ctx.contentNavigationFilter : contentNavigationFilter;
						myReportNavigationFilter    = ctx.myReportNavigationFilter ? ctx.myReportNavigationFilter : myReportNavigationFilter;
					}

					_self.saveStateNavigation(selectedIndexTab, selectedApplicationIndex, contentNavigationFilter, myReportNavigationFilter);
				});

				// List view
				_self.listMyReportsCallbacks = {
					callbacks : {
						handleDrop 		: null,						
						itemsCreateMenu : null,
						clickedItemOnCreateMenu : null,
						onFilterChange 	: null,
						onLoad 			: null,
						onRightClick   	: null,
						getIcon			: getIconByElement,
						doubleClick 	: openMyReport
					}
				};
				
				_self.listPublishedCallbacks = {
					callbacks : {
						handleDrop 		: null,						
						itemsCreateMenu : null,
						clickedItemOnCreateMenu : null,
						onFilterChange 	: null,
						onLoad 			: null,
						onRightClick   	: null,
						getIcon			: getIconByElement,
						doubleClick 	: openPublishedContent
					}
				};
				
				_self.layoutOpts = {
					header :{
						columns : [{
							mainKey : 'name',
							label : nameLabel,
							flex: '45'
						},{
							mainKey : 'description',
							label : descriptionLabel,
							flex: '50'
						}]
					},
					content :{
						columns : [{
							mainKey : 'name',
							textLabelFn : (item) => {
								return item.nodeInfo.name;
							},
							flex: '45'
						},{
							mainKey : 'description',
							textLabelFn : (item) => {
								return item.nodeInfo.description;
							},
							flex: '50'
						}]
					}
				};
				
				_self.orderPropertyName		= 'preferredPosition';
			}
		}
		
		openImageUploadModal($event) {
			let _self = this;
			_self.dcyDialogFactory.createImageUploadModal(_.extend({}, uploadDialogParams, {targetEvent : $event, event : $event})).then(response => {
				response.promise.then(function(response){
					if(_.isObject(response)){
						$scope.$emit('dcy.imageUploadForm.complete', response);
					}
				});
			});
		}
	}

	window.LandingPageController = LandingPageController;
	
})(window.Utilities, window.ModelsRestProvider, window.CassiopeaTypesEnum, window.EditorElementDataManager, window.ReportsRestProvider);